import { classnames } from "@/utils";
import styles from "./ProgressBar.module.scss";
import { useOnboarding } from "@/hooks/useOnboarding";
import { onboardingGraph } from "@/data/onboarding";

export default function ProgressBar() {
  const { currentQuestionId } = useOnboarding();
  const currentStep = onboardingGraph[currentQuestionId];
  let type = "standard";
  let flowProgress = currentStep.flowProgress || 0;

  if (currentStep.type === "disqualification") {
    type = "disqualification";
    flowProgress = 1;
  }

  const progressStyle = {
    "--progress": `${flowProgress * 100}%`,
  } as React.CSSProperties;

  if (currentStep.disqualificationType === "lowRisk") {
    return null;
  }

  return (
    <div className={classnames([styles.wrapper, styles[type]])}>
      <div className={styles.progress} style={progressStyle}></div>
    </div>
  );
}
